var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.56)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M13.861,2.776A5.531,5.531,0,0,0,9.058,0H8.047A5.507,5.507,0,0,0,3.259,2.776a5.249,5.249,0,0,0-.7,2.644V8.783a3.3,3.3,0,0,0,3.257,3.2.505.505,0,0,0,.52-.514V5.743a.505.505,0,0,0-.52-.514,3.2,3.2,0,0,0-2.23.925V5.405a4.364,4.364,0,0,1,.565-2.144A4.5,4.5,0,0,1,8.062,1H9.073a4.486,4.486,0,0,1,3.9,2.262,4.405,4.405,0,0,1,.565,2.144v.749a3.169,3.169,0,0,0-2.23-.925.505.505,0,0,0-.52.514v5.743A.505.505,0,0,0,11.3,12,3.325,3.325,0,0,0,14.56,8.783V5.42A5.329,5.329,0,0,0,13.861,2.776Z",
    transform: "translate(-2.56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.b55a1aa74c06e4be153bab19e8bd4e74.svg";
export { ForwardRef as ReactComponent };